import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import {
	type CreateCsvUploadResponse,
	httpCreateCsvUpload
} from '@/features/luxe-submissions/http/luxe-submissions.http'
import { errorHandler } from '@/helpers/utils'

export const useCreateCsvUpload = (
	options?: Omit<
		UseMutationOptions<CreateCsvUploadResponse, unknown, string>,
		'mutationFn'
	>
) =>
	useMutation({
		mutationFn: (fileName: string) => httpCreateCsvUpload(fileName),
		...options,
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		}
	})
